<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="settings != null"
>
    <v-card>
        <v-card-title>{{settings.organization_label}}:  NRR Settings</v-card-title>

        <v-card-text>

            <v-checkbox
                label="Include in NRR calculation"
                v-model="settings.include_in_nrr_calculation"
            />

            <v-select
                label="Cancellation reason"
                v-model="settings.cancellation_reason"
                :items="$rc.enumValues('red_chirp_cancellation_reason', true)"
            />

            <a
                v-if="settings.cancellation_reason != null"
                v-on:click="onClickClearCancellationReason"
            >
                Clear cancellation reason
            </a>

            <v-textarea
                label="Notes"
                rows="1"
                auto-grow
                v-model="settings.notes"
            />

             <a
                v-if="settings.notes != null"
                v-on:click="onClickClearNotes"
            >
                Clear notes
            </a>

            
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            settings: null,
        }
    },

    methods: {

        showDialog(settings)
        {
            this.settings = _.cloneDeep(settings);
            this.dialog = true;
        },

        onClickClearCancellationReason()
        {
            this.settings.cancellation_reason = null;
        },

        onClickClearNotes()
        {
            this.settings.notes = null;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/red-chirp-revenue/nrr',
            
                'params' : this.settings,
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('change');
                    },
            
                'on_error': 'Unable to save NRR settings',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>